<template>
    <div>
        <b-overlay
            :show="loading"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="d-inline-block"
        >
            <b-button
                :disabled="disabled || loading"
                :variant="variant"
                @click="$emit('click')"
            >
                <slot>{{ text }}</slot>
            </b-button>
        </b-overlay>
    </div>
</template>

<script>
export default {
    name: "LoadingButton",
    props: {
        disabled:{
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: "Submit"
        },
        variant: {
            type: String,
            default: "primary"
        }
    }
}
</script>
